import { eula_en } from './eula_en';

export const locale_en = {
  ...eula_en,
  AddNew: 'Add new',
  SearchText: 'Input search text...',
  Cancel: 'Cancel',
  OK: 'OK',
  Yes: 'Yes',
  No: 'No',
  Description: 'Description',
  English: 'English',
  Spanish: 'Español',
  Portuguese: 'Português',
  Russian: 'русский',
  French: 'Français',
  MyProfile: 'My profile',
  CloseSession: 'Close session',
  Settings: 'Settings',
  hrs: 'hrs',
  EditTask: 'Edit task',
  DeleteTaskQuestion: '¿Are you sure delete this task?',
  Delete: 'Delete',
  Reader: 'Reader',
  Contributor: 'Contributor',
  Permissions: 'Permissions',
  Welcome: 'Welcome',
  SelectEntity: 'Select entity',
  SetEntityTitle: 'Set Entity Title',
  SetEntityType: 'Set Entity Type',
  Add: 'Add',
  SelectGroup: 'Select Group',
  SelectGroups: 'Select Groups',
  SelectOrganization: 'Select organization',
  SelectPermissions: 'Select Permissions',
  EntityType: 'Entity Type',
  SelectRoles: 'Select roles',
  SelectUser: 'Select user',
  SelectUsers: 'Select users',
  SelectVisibility: 'Select visibility',

  Name: 'Name',
  PleaseEnterName: 'Please enter a name',
  PleaseSelectASelector: 'Please select a selector',
  Save: 'Save',
  Reset: 'Reset',
  AddMembersToGroup: 'Add members to group',
  AreYouSureRemove: 'Are you sure want remove',
  AreYouSureRemoveMember: 'Are you sure want remove {0} member from group?',
  AreYouSureRemoveMembers: 'Are you sure want remove {0} members from group?',
  User: 'User',
  Search: 'Search',
  AddMembers: 'Add members',
  Reload: 'Reload',
  AssignPermissionsToGroup: 'Assign permissions to group',
  Entity: 'Entity',
  Roles: 'Roles',
  Role: 'Role',
  AdminRoles: 'Admin Roles',
  DefaultRoles: 'Default Roles',
  PermissionsAssigned: 'Permissions Assigned',
  SearchEntity: 'Search Entity',
  AssignNewRolesToGroup: 'Assign new roles to group',
  AreYouSureWantToUnassignRole: 'Are you sure want to unassign {0} role',
  AreYouSureWantToUnassignRoles: 'Are you sure want to unassign {0} roles',
  AssignedRoles: 'Assigned roles',
  AssignRoles: 'Assign Roles',
  GroupParam: 'Group {0}',
  Members: 'Members',
  Groups: 'Groups',
  NewGroup: 'New Group',
  IdentityAdministration: 'Identity Administration',
  OrganizationsManagement: 'Organizations Management',
  UsersManagement: 'Users Management',
  RolesManagement: 'Roles Management',
  AdminRolesManagement: 'Admin Roles Management',
  GroupsManagement: 'Groups Management',
  PermissionsManagement: 'Permissions Management',
  RoleAssignmentsManagement: 'Role Assignments Management',
  DefaultRolesManagement: 'Default Roles Management',
  AuditLogs: 'Audit Logs',
  Organizations: 'Organizations',
  Users: 'Users',
  Assignments: 'Assignments',
  Logout: 'Logout',
  OrganizationDatabaseHasBeenCreated: 'Organization database has been created',
  SomethingWentWrong: 'Something went wrong',
  OrganizationHasBeenBlocked: 'Organization has been blocked',
  OrganizationHasBeenUnblocked: 'Organization has been unblocked',
  EditPartnerOrganization: 'Edit partner organization',
  SelectOrRemovePartnerOrganizationMessage: 'Select a new partner organization for {0}',
  PleaseSelectAPartnerOrganization: 'Please select a partner organization',
  Warning: 'Warning',
  TestingEndDateAutomaticallyChangedWarning:
    "The selected partner organization's testing end date is earlier than the currently selected testing end date for this organization. The testing end date has been updated automatically to match the partner organization's testing end date.",
  OrgCannotChangePartnerStatusWarning: 'The partner status of this organization cannot be modified while it has child organizations.',
  IsPartner: 'Is Partner',
  IsBlocked: 'Is Blocked',
  DisplayName: 'Display Name',
  Email: 'Email',
  PleaseEnterAValidEmail: 'Please enter a valid email',
  Address: 'Address',
  PleaseEnterAnAddress: 'Please enter an address',
  PartnerOrganization: 'Partner Organization',
  EnsureDB: 'Ensure DB',
  Unblock: 'Unblock',
  Block: 'Block',
  AddMembersToOrganization: 'Add members to organization',
  OrganizationMembers: 'Organization members',
  OrganizationParam: 'Organization {0}',
  NewOrganization: 'New organization',
  CreatingOrganizationMessage: 'Creating organization and its database. This could take several minutes. Please wait',
  RoleAssignments: 'Role Assignments',
  Identity: 'Identity',
  SelectType: 'Select Type',
  Group: 'Group',
  IdentityType: 'Identity Type',
  SearchIdentity: 'Search Identity',
  NewRolesAssignment: 'New Roles Assignment',
  Visibility: 'Visibility',
  PleaseSelect: 'Please Select',
  Category: 'Category',
  PleaseEnterACategory: 'Please enter a category',
  AssignNewRolesToPermission: 'Assign new roles to permission',
  PermissionParam: 'Permission {0}',
  NewPermission: 'New permission',
  Organization: 'Organization',
  AddRoleToGroups: 'Add role to groups',
  AreYouSureRemoveRole: 'Are you sure you want remove role from',
  RoleGroups: 'Role groups',
  AddToGroups: 'Add to groups',
  AddPermissionsToRole: 'Add permissions to role',
  Permission: 'Permiso',
  RolePermissions: 'Role permissions',
  AddToPermissions: 'Add To Permissions',
  AddUsersToRole: 'Add users to role',
  RoleUsers: 'Role users',
  AddUsers: 'Add users',
  RolParam: 'Role {0}',
  NewRole: 'New role',
  AddUserToGroups: 'Add user to groups',
  AreYouSureRemoveUserFromGroup: 'Are you sure want remove user from {0} group',
  AreYouSureRemoveUserFromGroups: 'Are you sure want remove user from {0} groups',
  GroupMembership: 'Group membership',
  AssignPermissionsToUser: 'Assign permissions to user',
  AssignNewRolesToUser: 'Assign new roles to user',
  UserParam: 'User {0}',
  PasswordMustMatch: 'Password must match',
  NewUser: 'New user',
  PleaseSelectAnOrganization: 'Please select an organization',
  SetPassword: 'Set password',
  SendInvitation: 'Send Invitation',
  Password: 'Password',
  ConfirmPassword: 'Confirm password',
  PasswordFieldBlankMessage:
    'If you leave the password field blank, the system will assume that this user will use an external authentication provider to login',
  AdminZone: 'Admin zone',
  ReviewClaims: 'Review Claims',
  ReviewGrants: 'Review Grants',
  PageDoesNotExist: 'Sorry, the page you visited does not exist',
  BackHome: 'Back Home',
  Home: 'Home',
  DontHaveAccessToTheAdminSite: "You don't have access to the admin site",
  RedirectingToLandingPage: 'Redirecting to landing page in',
  Go: 'Go',
  DefaultLanguage: 'Default Language',
  PleaseSelectALanguage: 'Please select a language',
  SelectLanguage: 'Select language',
  Languages: 'Languages',
  to: 'to',
  from: 'from',
  DownloadTemplate: 'Download template',
  ConfirmationRequired: 'Confirmation required',
  Confirmation: 'Confirmation',
  AreYouSureDeleteAllItems: 'Are you sure you want to delete all items?',
  AreYouSureYouWantToDelete: 'Are you sure you want to delete selected items?',
  AreYouSureYouWantToDeleteSelected: 'Are you sure you want to delete selected items?',
  UploadComplete: 'Upload complete',
  DeleteElements: 'Delete elements',
  DeleteItems: 'Delete elements',
  DeleteSelected: 'Delete selected',
  BulkUploadItems: 'Bulk upload items',
  DeleteAll: 'Delete All',
  OrderBy: 'Order by',
  AnErrorOcurred: 'An error ocurred',
  NoData: 'No data',
  ResetFilter: 'Reset filter',
  SelectAll: 'Select all',
  FilterConfirm: 'Filter confirm',
  Filter: 'Filter',
  InvertSelection: 'Invert selection',
  Sort: 'Sort',
  ElementsDeletedSuccessfully: 'Elements were deleted successfully',
  AreYouSureDiscardChanges: 'Are you sure that you want to discard these changes?',
  TotalElements: 'Total elements',
  TotalImported: 'Total imported',
  Errors: 'Errors',
  DownloadWarningsFile: 'Download warnings file',
  Warnings: 'Warnings',
  UnsavedValuesWarning: 'There are unsaved changes, are you sure you want to leave?',
  DeletedElements: 'Deleted elements',
  FailDeletion: 'Deletion Failed ',
  NotSet: 'Not set',
  CanNotDeleteOwnUser: "Can't delete own user",
  CanNotDeleteOwnOrganization: "Can't delete own Organization",

  //Home
  WelcomeBack: 'Welcome back, {0}!',
  PageDoesNotExists: 'Sorry, the page you visited does not exist.',

  //Paging
  Page: 'Page',
  GoTo: 'Go to',

  //Roles Views
  Selector: 'Selector',
  AssignToScopeCreator: 'Assign to Scope Creator',
  EditRole: 'Edit Role',
  Edit: 'Edit',
  EditDefaultRole: 'Edit Default Role',
  CreateDefaultRole: 'Create Default Role',
  NewDefaultRole: 'New Default Role',
  DeleteMember: 'Delete member',
  DeleteMembers: 'Delete memebers',
  RemoveMember: 'Delete member',
  RemoveMembers: 'Delete memebers',
  CreateRole: 'Create Role',
  RolesPermissions: 'Roles permissions',
  GeneralProperties: 'General Properties',
  SelectSelector: 'Select Selector',
  AssignByDefaultToScopeCreator: 'Assign by default to Scope Creator',
  SaveChanges: 'Save Changes',
  Allow: 'Allow',
  Deny: 'Deny',
  Partners: 'Partners',
  EditAdminRole: 'Edit Admin Role',
  RoleName: 'Role Name',
  NewAdminRole: 'New Admin Role',
  PartnersOnlyQuestion: 'Partners Only?',
  PartnersOnly: 'Partners Only',
  DefaultRoleWarning:
    'This Default Role generates Roles that are being assigned by default to creators of some types of scopes. Proceed with caution',
  DefaultRoleDeleteWarning:
    'This Default Role generates Roles that are being assigned by default to creators of some types of scopes. Are you sure you want to delete it?',
  ChooseIdentity: 'Choose Identity:',
  RoleIsBeingAssignedToDefaultCreators: 'This Role is being assigned by default to creators of some types of scopes. Proceed with caution',
  RoleIsBeingAssignedToDefaultCreatorsDelete:
    'This Role is being assigned by default to creators of some types of scopes. Are you sure you want to delete it?',
  RoleDelete: 'Are you sure you want to delete this role?',
  DefaultRoleDelete: 'Are you sure you want to delete this default role?',

  //Permissions
  PleaseEnterADescription: 'Please enter a description',
  AddNewRolesToPermission: 'Add new roles to permission',
  DeleteRole: 'Delete role',
  DeleteRoles: 'Delete roles',
  AddNewPermission: 'Add New Permission',
  AddPermission: 'Add permission',
  //Admin
  CreatePartnerOrganization: 'Create Partner Organization',
  DeletePartnerOrganization: 'Delete Partner Organization',
  ManageDefaultRoles: 'Manage Default Roles',
  ManagePermissions: 'Manage Permissions',
  //Partners
  BlockOrganization: 'Block Organization',
  CreateOrganization: 'Create Organization',
  DeleteOrganization: 'Delete Organization',
  ManageLicenses: 'Manage Licenses',
  ManageRoleAssignment: 'Manage Role Assignments',
  //Organization
  CreateProject: 'Create Project',
  ManageGroups: 'Manage Groups',
  ManageOrganizationInfo: 'Manage Organization Info',
  ManageOrganizationRoleAssignments: 'Manage Organization Role Assignments',
  ManageQuarantine: 'Manage Quarantine',
  ManageRecycleBin: 'Manage Recycle Bin',
  ManageRoles: 'Manage Roles',
  ManageUnitSystem: 'Manage Unit System',
  ManageUsers: 'Manage Users',
  AddOrganization: 'Add Organization',
  //Project
  CreateDrillhole: 'Create Drillhole',
  DeleteProject: 'Delete Project',
  ManageProjectInfo: 'Manage Project Info',
  ManageProjectRoleAssignments: 'Manage Project Role Assignments',
  ViewProjectData: 'View Project Data',
  //Ring
  CreateRing: 'Create Ring',
  DeleteRing: 'Delete Ring',
  ManageRingInfo: 'Manage Ring Info',
  ManageRingRoleAssignments: 'Manage Ring Role Assignments',
  ShareRing: 'Share Ring',
  ViewRingData: 'View Ring Data',
  CreateRingDrillhole: 'Create Ring Drillholes',
  //Drillhole
  DeleteDrillhole: 'Delete Drillhole',
  ManageDrillholeInfo: 'Manage Drillhole Info',
  ManageDrillholeRoleAssignments: 'Manage Drillhole Role Assignments',
  ViewDrillholeData: 'View Drillhole Data',
  ManageSurveys: 'Manage Surveys',
  SynchronizeSurveys: 'Synchronize Surveys',

  //GroupViews
  RowsSelected: 'row(s) selected',
  AddToMembers: 'Add to members',
  AssignRolesToGroup: 'Assign roles to group',
  Scope: 'Scope',
  ScopeType: 'Scope Type',
  SearchScope: 'Search Scope',
  AddGroup: 'Add Group',
  AddNewGroup: 'Add new group',
  DeleteGroup: 'Delete Group',
  DeleteGroups: 'Delete Groups',
  GroupLogs: "Group's Logs",
  GroupInfo: 'Group info',
  GroupMembers: 'Group Members',
  CheckGroupInfoAndUsersTabs: 'Please check the group info and members tabs. Something is wrong',

  //Organizations:
  PleaseCheckTheInfoProvided: 'Please check the info provided. Something is wrong',
  PleaseSelectOrRemoveRow: 'Please select or remove row',
  AreYouSureRemoveMemberFromOrg: 'Are you sure want remove {0} member from organization?',
  AreYouSureRemoveMembersFromOrg: 'Are you sure want remove {0} members from organization?',
  DeleteUsers: 'Delete Users',
  InvitationSent: 'Invitation Sent',
  InvitationNotSent: 'Invitation Not Sent',
  ResendInvitation: 'Resend Invitation',
  SendResetPasswordEmail: 'Send Reset Password Email',
  ResetPasswordEmailSent: 'Email Sent',
  ResetPasswordEmailNotSent: 'Email Not Sent',
  TypeOrganizationNameToConfirm: 'Type Organization name to confirm',
  CanNotDeletePartnerOrganizations: "Can't delete partner organizations",
  CanNotDeleteOrganizations: "Can't delete organizations",
  CheckOrganizationInfoAndUsersTabs: 'Please check the organization info and users tabs. Something is wrong',
  AddNewOrganization: 'Add New Organization',
  SelectOrInviteOrganizationMaster: 'Select or Invite Organization Master',
  PleaseSelectInviteOrRemoveRow: 'Please select, invite or remove row',
  AddUser: 'Add User',
  AddNewUser: 'Add New User',

  //Users
  RemoveMembership: 'Remove Membership',
  RemoveMemberships: 'Remove Memberships',
  UsersLogs: "User's Logs",
  AssignRolesToUser: 'Assign Roles To User',
  RolesAssigned: 'Roles Assigned',
  BalnkPasswordWarning:
    'If you leave the password field blank, the system will assume that this user will use an external authentication provider to login.',
  DeleteUser: 'Delete user',
  ConfirmDeleteUser: 'Are you sure you want to delete user "{0}" with email address "{1}"?',
  UserDeleted: 'User "{0}" with email address "{1}" has been successfully deleted.',
  //AuditLogs
  Timestamp: 'Timestamp',
  DisplayingFilteredItems: 'Displaying items filtered by a notification.',
  ShowAllItems: 'Show all items',
  NotificationTimestampMessageMinutes: '{0} minutes ago',
  NotificationTimestampMessageHours: '{0} hours ago',
  Yesterday: 'Yesterday',
  Read: 'Read',
  Unread: 'Unread',
  Action: 'Action',
  AffectedElement: 'Affected element',
  LinkTo: 'Link to',
  State: 'State',
  Date: 'Date',
  Notifications: 'Notifications',
  NotificationStatus: 'Notification status',
  InApp: 'In app',
  NotificationsSettings: 'Notifications settings',
  DeleteAfter: 'Delete after',
  OneWeek: 'One week',
  OneMonth: 'One month',
  OneYear: 'One year',
  ThreeMonths: 'Three months',
  SixMonths: 'Six months',
  DeleteAllNotifications: 'Delete all',
  SurveySynchedRingNotificationDescription: 'The survey "{A}" has been synchronized on drillhole "{B}".',
  SurveySynchedDrillholeNotificationDescription: 'The survey "{A}" has been synchronized on ring "{B}".',
  SurveySynchedQuarantineNotificationDescription: 'The survey "{A}" has been synchronized on the quarantine.',
  OrganizationCreationFinishedNotificationTitle: 'Organization created',
  OrganizationExpirationWarningNotificationTitle: 'Organization about to expire',
  OrganizationCreationErrorNotificationTitle: 'Error creating Organization',
  OrganizationIsAvailableNotificationTitle: 'Organization available',
  LicenseNeedsApprovalNotificationTitle: 'License needs approval',
  LicenseWasRenewedNotificationTitle: 'License was renewed',
  RingCreatedNotificationTitle: 'Ring created',
  SurveySynchedNotificationTitle: 'Survey synchronized',
  ProjectDeletedNotificationTitle: 'Project deleted',
  ProjectEditedNotificationTitle: 'Project edited',
  DrillholeDeletedNotificationTitle: 'Drillhole deleted',
  RingDeletedNotificationTitle: 'Ring deleted',
  DrillholeMovedNotificationTitle: 'Drillhole moved',
  RingMovedNotificationTitle: 'Ring moved',
  DrillholeEditedNotificationTitle: 'Drillhole updated',
  RingEditedNotificationTitle: 'Ring updated',
  SurveySignoffNotificationTitle: 'Survey signoff request',
  DrillholeCreatedNotificationTitle: 'Drillhole created',
  BulkDrillholesUpdateNotificationTitle: 'Drillholes edited',
  BulkDrillholesMovedNotificationTitle: 'Drillholes moved',
  BulkRingsMovedNotificationTitle: 'Rings moved',
  BulkDrillholesDeletedNotificationTitle: 'Drillholes deleted',
  BulkRingsDeletedNotificationTitle: 'Rings deleted',
  BulkProjectsDeletedNotificationTitle: 'Projects deleted',
  BulkRingsCreatedNotificationTitle: 'Rings created',
  BulkDrillholesCreatedNotificationTitle: 'Drillholes created',
  SurveyDeletedNotificationTitle: 'Survey deleted',
  SurveyDeletedNotificationDescription: 'Survey "{A}" was deleted.',
  OrganizationCreationFinishedNotificationDescription: 'Organization {A} was created with {X} members.',
  OrganizationExpirationWarningNotificationDescription: 'Organization {A} is about to expire.',
  OrganizationCreationErrorNotificationDescription: 'There was an error creating Organization {A}.',
  OrganizationIsAvailableNotificationDescription: 'Organization {A} is now available.',
  LicenseNeedsApprovalNotificationDescription: 'A license with tool code {A} needs approval.',
  LicenseWasRenewedNotificationDescription: 'A license with tool code {A} was renewed.',
  SurveySynchedNotificationDescription: 'The survey "{A}" has been synchronized on drillhole "{B}".',
  ProjectDeletedNotificationDescription: 'Project "{A}" was deleted.',
  ProjectEditedNotificationDescription: 'Project "{A}" was edited.',
  DrillholeDeletedNotificationDescription: 'Drillhole "{A}" was deleted.',
  RingDeletedNotificationDescription: 'Ring "{A}" was deleted.',
  DrillholeMovedNotificationDescription: 'The drillhole "{B}" was moved to "{A}".',
  RingMovedNotificationDescription: 'The ring "{B}" was moved to project "{A}".',
  DrillholeEditedNotificationDescription: 'The drillhole "{A}" was updated',
  RingEditedNotificationDescription: 'The ring "{A}" was updated',
  SurveySignoffNotificationDescription: 'A signoff was requested for survey "{A}".',
  DrillholeCreatedNotificationDescription: 'A drillhole with name "{B}" has been created on "{A}".',
  RingCreatedNotificationDescription: 'A ring with name "{B}" was created in project "{A}".',
  BulkDrillholesUpdateNotificationDescription: '{X} drillholes were edited on "{B}".',
  BulkDrillholesMovedNotificationDescription: '{X} drillholes were moved to "{B}".',
  BulkRingsMovedNotificationDescription: '{X} rings were moved to project "{B}".',
  BulkDrillholesDeletedNotificationDescription: '{X} drillholes were deleted',
  BulkRingsDeletedNotificationDescription: '{X} rings were deleted',
  BulkProjectsDeletedNotificationDescription: '{X} projects were deleted.',
  BulkRingsCreatedNotificationDescription: '{X} rings were created.',
  BulkDrillholesCreatedNotificationDescription: '{X} drillholes were created on "{B}".',
  ForgotPasswordNotificationTitle: 'Password reset email sent',
  OrganizationInvitationNotificationTitle: 'Organization invitation received',
  LicenseQRSharedNotificationTitle: 'License shared with you',
  ToolUsageReportNotificationTitle: 'Tool usage report ready',
  OrganizationCreationFinishedNotificationTitleError: 'Error creating organization',
  OrganizationIsAvailableNotificationTitleError: 'Error making organization available',
  LicenseWasRenewedNotificationTitleError: 'Error renewing license',
  RingCreatedNotificationTitleError: 'Error creating ring',
  SurveySynchedNotificationTitleError: 'Error synchronizing survey',
  ProjectDeletedNotificationTitleError: 'Error deleting project',
  ProjectEditedNotificationTitleError: 'Error editing project',
  DrillholeDeletedNotificationTitleError: 'Error deleting drillhole',
  RingDeletedNotificationTitleError: 'Error deleting ring',
  DrillholeMovedNotificationTitleError: 'Error moving drillhole',
  RingMovedNotificationTitleError: 'Error moving ring',
  DrillholeEditedNotificationTitleError: 'Error updating drillhole',
  RingEditedNotificationTitleError: 'Error updating ring',
  DrillholeCreatedNotificationTitleError: 'Error creating drillhole',
  BulkDrillholesUpdateNotificationTitleError: 'Error editing drillholes',
  BulkDrillholesMovedNotificationTitleError: 'Error moving drillholes',
  BulkRingsMovedNotificationTitleError: 'Error moving rings',
  BulkDrillholesDeletedNotificationTitleError: 'Error deleting drillholes',
  BulkRingsDeletedNotificationTitleError: 'Error deleting rings',
  BulkProjectsDeletedNotificationTitleError: 'Error deleting projects',
  BulkRingsCreatedNotificationTitleError: 'Error creating rings',
  BulkDrillholesCreatedNotificationTitleError: 'Error creating drillholes',
  SurveyDeletedNotificationTitleError: 'Error deleting survey',
  ForgotPasswordNotificationTitleError: 'Error sending password reset email',
  OrganizationInvitationNotificationTitleError: 'Error sending organization invitation',
  LicenseQRSharedNotificationTitleError: 'Error sharing license',
  ToolUsageReportNotificationTitleError: 'Error generating tool usage report',

  SurveyDeletedNotificationDescriptionError: 'There was an error deleting survey "{A}".',
  OrganizationCreationFinishedNotificationDescriptionError: 'There was an error creating organization {A}.',
  OrganizationIsAvailableNotificationDescriptionError: 'There was an error making organization {A} available.',
  LicenseWasRenewedNotificationDescriptionError: 'There was an error renewing the license with tool code {A}.',
  SurveySynchedNotificationDescriptionError: 'There was an error synchronizing survey "{A}" on drillhole "{B}".',
  ProjectDeletedNotificationDescriptionError: 'There was an error deleting project "{A}".',
  ProjectEditedNotificationDescriptionError: 'There was an error editing project "{A}".',
  DrillholeDeletedNotificationDescriptionError: 'There was an error deleting drillhole "{A}".',
  RingDeletedNotificationDescriptionError: 'There was an error deleting ring "{A}".',
  DrillholeMovedNotificationDescriptionError: 'There was an error moving drillhole "{B}" to "{A}".',
  RingMovedNotificationDescriptionError: 'There was an error moving ring "{B}" to project "{A}".',
  DrillholeEditedNotificationDescriptionError: 'There was an error updating drillhole "{A}".',
  RingEditedNotificationDescriptionError: 'There was an error updating ring "{A}".',
  DrillholeCreatedNotificationDescriptionError: 'There was an error creating drillhole "{A}" on "{B}".',
  RingCreatedNotificationDescriptionError: 'There was an error creating ring "{A}" in project "{B}".',
  BulkDrillholesUpdateNotificationDescriptionError: 'There was an error editing {X} drillholes on "{B}".',
  BulkDrillholesMovedNotificationDescriptionError: 'There was an error moving {X} drillholes to "{A}".',
  BulkRingsMovedNotificationDescriptionError: 'There was an error moving {X} rings to project "{A}".',
  BulkDrillholesDeletedNotificationDescriptionError: 'There was an error deleting {X} drillholes.',
  BulkRingsDeletedNotificationDescriptionError: 'There was an error deleting {X} rings.',
  BulkProjectsDeletedNotificationDescriptionError: 'There was an error deleting {X} projects.',
  BulkRingsCreatedNotificationDescriptionError: 'There was an error creating {X} rings.',
  BulkDrillholesCreatedNotificationDescriptionError: 'There was an error creating {X} drillholes on "{B}".',
  ForgotPasswordNotificationDescriptionError: 'There was an error sending the password reset email.',
  OrganizationInvitationNotificationDescriptionError: 'There was an error with an organization invitation. Please verify.',
  LicenseQRSharedNotificationDescriptionError: 'There was an error sharing the license.',
  ToolUsageReportNotificationDescriptionError: 'There was an error generating or sending the tool usage report.',
  SurveySynchedRingNotificationDescriptionError: 'There was an error synchronizing survey "{A}" on drillhole "{B}".',
  SurveySynchedDrillholeNotificationDescriptionError: 'There was an error synchronizing survey "{A}" on ring "{B}".',
  SurveySynchedQuarantineNotificationDescriptionError: 'There was an error synchronizing survey "{A}" in the quarantine.',
  IsRead: 'Read',
  RelatedEntityName: 'Related entity name',
  RelatedEntityType: 'Related entity type',
  RedirectEntityName: 'Redirect entity name',
  RedirectEntityType: 'Redirect entity type',
  Count: 'Count',
  Enable: 'Enable',
  SendNotificationsViaEmail: 'Send notifications via email',
  TypeHeader: 'Type',

  ForgotPasswordNotificationDescription: 'An email containing a password reset link has been sent.',
  OrganizationInvitationNotificationDescription: 'You have been invited to join an organization. Please check your email for more details.',
  LicenseQRSharedNotificationDescription: 'A license has been shared with you. Please check your email for more details.',
  ToolUsageReportNotificationDescription: 'The tool usage report was successfully generated and sent to your email.',
  Now: 'Now',
  EmptyNotificationsTextTitle: 'You’re all caught up!',
  EmptyNotificationsTextSubtitle: 'You have no new notifications',
  LastWeek: 'Last week',
  Today: 'Today',
  ThisWeek: 'This week',
  ThisMonth: 'This month',
  MarkAsRead: 'Mark as read',
  MarkAsReadAll: 'Mark as read',
  LogType: 'Log Type',
  RelatedEntity: 'Related Entity',
  // Error
  UnexpectedError: 'Unexpected Error',
  Unauthorized: 'Unauthorized',
  NoAccessToAdminSite: 'You dont have access to the admin site',
  LoginOutInSecs: 'Login out in {0} seconds',
  CrashError: 'Oops! Something went really wrong',
  SeeAllLogs: 'Please press F12 and send all logs in the Console tab when you report this incident',
  ReturnHome: 'Return Home',
  OrganizationUsers: 'Organization Users',
  IsPartnerQuestion: 'Is Partner?',

  FixResult: 'Fix result',
  NoInconsistenciesFound: 'No inconsistencies found',
  Type: 'Type',
  Parent: 'Parent',
  'Parent Type': 'Parent Type',
  Problem: 'Problem',
  Fixed: 'Fixed',
  PleaseTryAgainLater: 'Please try again later',
  FixInconsistencies: 'Fix inconsistencies',
  AssignRoleWarning:
    'You are assigning roles: {0} to {1} at level of organization. The roles will be applied to all selected entities and {1} will have permission to all information contained in {2}',
  UpdateExpiredRoleWarning:
    'The roles: {0} were previously assigned to {1} but have expired. The selected date will replace the previous expiration date, and the roles will become active again.',

  DoYouWantToContinue: 'Do you want to continue?',
  MemberAlreadyInOrganizarion: 'The user is already a member of the organization {0}',
  YouHaveSelectedThisUserMoreThanOnce: 'You have selected this user more than once',
  ClearFilter: 'Clear filter',
  ElementsSussessfulyDeleted: 'Elements sussessfuly deleted',
  DownloadErrorsFile: 'Download errors file',
  ImportCSV: 'Import CSV',
  Licenses: 'Licenses',
  ToolCode: 'Tool Code',
  DeviceType: 'Device Type',
  FromDate: 'From Date',
  UntilDate: 'Until Date',
  CreatedOn: 'Created On',
  CreatedBy: 'Created By',
  Unlimited: 'Unlimited',
  Coefficients: 'Coefficients',
  Continuous: 'Continuous',
  Multishot: 'Multishot',
  Zupt: 'Zupt',
  Offline: 'Offline',
  Flash: 'Flash',
  Notes: 'Notes',
  AddLicense: 'Add License',
  AddNewLicense: 'Add New License',
  PleaseEnterToolCode: 'Please enter tool code',
  LicenseCopied: 'License copied to clipboard',
  License: 'License',
  Copy: 'Copy',
  ErrorLoadingLicense: 'Error Loading License',
  ShowLicense: 'Show License',
  GoToLicense: 'Go to license',
  LicenseAlreadyExists: 'There is already a license with the same parameters that you entered',
  PeriodOfValidity: 'Period Of Validity',
  CopyLicense: 'Copy License',
  CopyAll: 'Copy All',
  PleaseSelectDates: 'Please Select Dates',
  Project: 'Project',
  Customer: 'Customer',
  ExportCSV: 'Export CSV',
  Reports: 'Reports',
  Export: 'Export',
  Separator: 'Separator',
  Tab: 'Tab',
  Semicolon: 'Semicolon',
  Comma: 'Comma',
  ThereWasAProblemCreatingLicense: 'There was a problem creating the license. Please, contact an admin.',
  ExpirationDate: 'Expiration Date',
  UpdateRoleAttributes: 'Update Role Attributes',
  Update: 'Update',
  AllowedDevices: 'Allowed Devices',
  RoleExpirationDate: 'Role Expiration Date',
  PleaseEnterExpirationDate: 'Please, enter an expiration date',
  MaximumLicenseDueDate: 'Maximum License Due Date',
  PleaseEnterMaxDueDate: 'Please, enter the maximum license due date',
  MaxLicensesPeriodInDays: 'Maximum License Period In Days',
  PleaseEnterMaxLicensesPeriodInDays: 'Please, enter the maximum license period in days',
  MaxNumberOfLicensesPerMonth: 'Maximum # Of Licenses Per Month',
  PleaseEnterMaxNumberOfLicensesPerMonth: 'Please, enter the maximum number of licenses per month',
  SignOffPending: 'Sign off Pending',
  SignedOffBy: 'Signed off by',
  SignedOffOn: 'Signed off On',
  SignOff: 'Sign off',
  Refuse: 'Refuse',
  NeedsSignOff: 'Sign off needed',
  SelectedUserAlreadyHasTheSelectedRoles: 'The selected user already has the roles: {0}.',
  CanCreateUnlimitedLicense: 'Can create non expiring licenses',
  CanCreateRecurrentLicenses: 'Can create recurrent licenses',
  Recurrence: 'Recurrence',
  Activated: 'Activated',
  Deactivated: 'Deactivated',

  Logs: 'Logs',
  LicenseLogs: 'License Logs',
  ViewLogs: 'View Logs',
  UserName: 'User Name',
  LicenseCreation: 'License Creation',
  LicenseUpdate: 'License Update',
  LicenseSignedOff: 'License Signed Off',
  LicenseRejected: 'License Rejected',
  ErrorCreatingLicenseMaximumLicenseDueDate: 'Error Creating License',
  ErrorCreatingLicenseMaxLicensesPeriodInDays: 'Error Creating License',
  ErrorCreatingLicenseMaxLicenseNumber: 'Error Creating License',
  ErrorCreatingLicenseAllowedDevices: 'Error Creating License',
  ErrorUpdatingLicenseMaximumLicenseDueDate: 'Error Updating License',
  ErrorUpdatingLicenseMaxLicensesPeriodInDays: 'Error Updating License',
  ErrorUpdatingLicenseAllowedDevices: 'Error Updating License',
  LicenseCreationDescription: 'A license was created by {0} for device {1} and tool type {2}.',
  LicenseUpdateDescription: 'A license was updated by {0}',
  LicenseCreationDescriptionExtraData:
    'A license was created by {0} with the following parameters: Device Type: {1}, Tool Number: {2}, {3}, Project: {4}, Customer: {5}.',
  LicenseUpdateDescriptionExtraData:
    'A license was updated by {0}.<br> Previous parameters: Device Type: {1}, Tool Number: {2}, {3}, Project: {4}, Customer: {5}.<br> Current Parameters: Device Type: {6}, Tool Number: {7}, {8}, Project: {9}, Customer: {10}.',
  LicenseDescriptionTimeData: 'from {0} until {1}',
  LicenseSignedOffDescription: '{0} signed off license created by {1} for device {2} and tool type {3}.',
  LicenseRejectedDescription: '{0} rejected license created by {1} for device {2} and tool type {3}.',
  ErrorCreatingLicenseMaximumLicenseDueDateDescription:
    "There was an error creating the license. The license can't have a due date later than the allowed maximum due date.",
  ErrorCreatingLicenseMaxLicensesPeriodInDaysDescription:
    'There was an error creating the license. The license must be valid for a period shorter than the allowed maximum license period.',
  ErrorCreatingLicenseMaxLicenseNumberDescription:
    'There was an error creating the license. The user exceeded the maximum number of licenses that can be created in a month.',
  ErrorCreatingLicenseAllowedDevicesDescription:
    'There was an error creating the license. The user does not have permissions to create licenses for the specified device.',
  ErrorUpdatingLicenseMaximumLicenseDueDateDescription:
    "There was an error updating the license. The license can't have a due date later than the allowed maximum due date.",
  ErrorUpdatingLicenseMaxLicensesPeriodInDaysDescription:
    'There was an error updating the license. The license must be valid for a period shorter than the allowed maximum license period.',
  ErrorUpdatingLicenseAllowedDevicesDescription:
    'There was an error updating the license. The user does not have permissions to define licenses for the specified device.',
  ExportingVeryLargeNumberOfItems:
    'You are trying to export very a large number of items, this could take some time. Are you sure you want to continue?',
  InitializingOrganization: 'Initializing Organization. Users will be available soon',
  InvalidToolCode: 'Tool code must have exactly four digits',
  EditRoles: 'Edit roles',
  EditRolesMessage: 'Edit user roles',
  RolesWillBeRemoved: 'The following roles will be removed: {0}. ',
  RolesWillBeAssigned: 'The following roles will be assigned: {0}. ',
  LicenseAttributesWillBeUpdated: 'The attributes for the License Manager role will be updated.',
  CheckDatabases: 'Check Databases',
  CheckDatabasesComplete: 'The check databases operation is complete',
  DatabaseCheckResultsModalTitle: 'Database check results:',
  ViewResults: 'View Results',
  CheckDatabaseResult: 'Check Database Result',
  OrganizationName: 'Organization Name',
  Status: 'Status',
  Success: 'Success',
  Error: 'Error',
  AddAssignments: 'Add Assignments',
  GroupsLogs: 'Group Logs',
  RelatedUser: 'Related User',
  OrganizationInfo: 'Organization Info',
  LicenseDetails: 'License Details',
  DatabaseCheckLogs: 'Database check logs',
  CheckingDatabases: 'Checking databases...',
  DatabaseLogs: 'Database Logs',
  DatabaseCheckLogsResult: 'Database check results',
  DatabaseCheckResultOnDate: 'Database check result on {0}',
  ExportingProcessStarted: 'The exporting process has started, the download will start soon.',
  ExportOrganization: 'Export Organization',
  ImportOrganization: 'Import Organization',
  UploadOrganizationBackup: 'Upload Organization Backup',
  AddOrganizationFile: 'Click or drag organization backup file to this area to upload',
  ThisUserIsOrganizationMaster: 'This user has been already selected as the organization master',
  RemainingLicensesMessage: 'You have a total of {0} licenses remaining for this month',
  MaxLicenseNumberReached: 'You have reached the maximum number of licenses for this month',
  EULATitle: 'End-User License Agreement (EULA)',
  OrganizationIsExporting: 'Organization is exporting, please wait...',
  ErrorExportingOrganization: 'There was an error exporting organization {0}. Please try again.',
  Restore: 'Restore',
  RestoreBackupConfirmMessage: 'Do you want to restore this backup? Any changes made to the organization after the backup was created will be lost.',
  RestoreBackupSuccessMessage: 'The backup restore process has started, when it finishes we will send a notification to your email address.',
  Backups: 'Backups',
  ExportingOrganizationSuccess: 'The export process has started, when it finishes we will send a download link to your email address.',
  ExportImportLogs: 'Export and Import Logs',
  CanNotDeleteOrganizationWhileExporting:
    'The organization {0} is being exported and cannot be deleted right now. Please wait and try again in a while.',
  CheckingIfOrganizationExists: 'Checking if organization exists...',
  RestoreOrganizationConfirmDialog:
    'This organization already exists, do you want continue? All data from this organization will be ovewritten with the backup data.',
  StatusCode: 'Status Code',
  Message: 'Message',
  Traces: 'Traces',
  ViewTrace: 'View Trace',
  ImportExportDevLogs: 'Import/Export Development Logs',
  DevLogs: 'Development Logs',
  DevLogsShort: 'Dev. Logs',
  ImportExport: 'Import/Export',
  ImportingOrganizationStarted: 'The import process has started',
  ImportingOrganizationSuccess: 'The import process has started, when it finishes we will send a notification to your email address.',
  ErrorImportingOrganization: 'There was an error importing the organization. Please try again.',
  Importing: 'Importing...',
  ResetLockout: 'Reset Lockout',
  LockoutReset: 'Lockout Reset',
  LockoutNotReset: 'Lockout Not Reset',
  HangfireDashboard: 'Hangfire Dashboard',
  LastImportDate: 'This organization was last restored from a backup on ',

  EventDuration: 'Event duration (hours)',
  ScheduledEvents: 'Scheduled events',
  ScheduledEvent: 'Scheduled event',
  VisibilityStartDate: 'Visibility start date',
  VisibilityEndDate: 'Visibility end date',
  EventType: 'Event type',
  ScheduledUpdate: 'Scheduled update',
  Announcement: 'Announcement',
  EventStart: 'Event start',
  ScheduledEventsTableError: 'There was an error loadint the events table.',
  EditScheduledEvent: 'Edit scheduled event',
  NewScheduledEvent: 'New scheduled event',
  UploadBanner: 'Upload banner',
  Banner: 'Banner',
  BannerSelectInfoMessage:
    'Banner images should use an 8:1 aspect ratio (width to height). Recommended resolutions include 800×100 pixels, 1600×200 pixels, or any other size that maintains this ratio. You will be able to crop the image before saving.',
  LocalizedAnnouncementInformation: 'Localized announcement information',
  LocalizedAnnouncementInformationDescription:
    'For each language selected, it will be displayed a banner or a message with the provided description to every user using that language. If both a banner and a description are provided, the description will be used as alt text for the banner. If the user uses a language not added, the announcement information for the English language will be used if available, and if not, it will be used the information from the first language of the list.',
  AddAtLeastOneLanguage: 'Please select at least one language',
  PleaseEnterVisibilityRange: 'Please enter a visibility range',
  PleaseLoadImageIfNoDescription: 'If a description is not provided, a banner image must be uploaded',
  PleaseEnterDescriptionIfNoImage: 'If a banner image is not provided, a text description must be added',
  PleaseEnterScheduledUpdateStartMoment: 'Please enter a start moment for the update',
  PleaseEnterScheduledUpdateDuration: 'Please enter a duration in hours for the update',
  Link: 'Link',
  SelectBannerArea: 'Select banner area',
  ScheduledMaintenanceText:
    'Scheduled Maintenance: The cloud platform will be undergoing scheduled maintenance on {0}. Services may be interrupted for an estimated duration of {1} hours, starting at {2}',

  AdminRolesTableError: 'There was an error loading admin roles. Please try again.',
  AuditLogsTableError: 'There was an error loading audit logs. Please try again.',
  DefaultRolesTableError: 'There was an error loading default roles. Please try again.',
  GroupsTableError: 'There was an error loading groups. Please try again.',
  ErrorSavingGroupProperties: 'There was an error saving the group properties. Please try again.',
  ErrorAddingGroupMembers: 'There was an error adding the members to the group. Please try again.',
  GroupRolesTableError: 'There was an error loading group roles. Please try again.',
  LicensesTableError: 'There was an error loading the licenses. Please try again.',
  LicenseLogsTableError: 'There was an error loading license logs. Please try again.',
  OrganizationsTableError: 'There was an error loading the organizations. Please try again.',
  ErrorAddingOrganizationMembers: 'There was an error adding the new members to the organization. Please try again.',
  ErrorRemovingOrganizationMembers: 'There was an error removing the new members from the organization. Please try again.',
  DatabaseLogsTableError: 'There was an error loading database logs. Please try again.',
  PermissionsTableError: 'There was an error loading permissions. Please try again.',
  ErrorSavingPermissions: 'There was an error saving the permission properties. Please try again.',
  ErrorAddingPermissionRoles: 'There was an error adding permissions to the role. Please try again.',
  ErrorRemovingPermissionRoles: 'There was an error removing the permission from the role. Please try again.',
  RoleAssignmentsTableError: 'There was an error loading the role assignmets. Please try again.',
  RoleListTableError: 'There was an error loading the roles. Please try again.',
  LockoutNotResetError: 'There was an error resetting the lockout. Please try again.',
  UsersTableError: 'There was an error loading the user list. Please try again.',
  ErrorAddingGroup: 'There was an error adding the group. Please try again.',
  ErrorRemovingGroup: 'There was an error removing the group. Please try again.',
  UserLogsTableError: 'There was an error loading user logs. Please try again.',
  UserRolesTableError: 'There was an error loading user roles. Please try again.',
  InvitationNotSentErrorMessage: 'There was an error sending the invitation. Please try again.',
  ResetPasswordEmailNotSentMessage: 'There was an error sending the password reset email. Please try again.',
  ErrorEditingLicenseAttributes: 'There was an error editing the license. Please try again.',
  ErrorDeletingUser: 'There was an error deleting the user. Please try again.',
  PaginationTotal: 'Showing {0} items of {1}',
  PaginationTotalItemsText: 'Showing {0}-{1} of {2} items',
  MinutesAbbreviation: 'min',
  EditTutorialInformation: 'Edit tutorial information',
  Order: 'Order',
  VideoOrder: 'Video order',
  FuntionTitle: 'Function',
  VideoFunction: 'Video function',
  PleaseEnterVideoOrder: 'Please enter video order',
  AddFunction: 'Add function',
  FunctionAlreadyExistsWarning: 'There is already a function with that name. Please verify.',
  SearchTutorials: 'Search tutorials',
  VideoTutorials: 'Video tutorials',
  ManageVideoTutorialData: 'Manage video tutorial data',
  SynchronizeThisVideoAfterOperationFinishes: 'Synchronize this video after operation finishes',
  AddTutorialInformation: 'Add tutorial information',
  VideoId: 'Video ID',
  TutorialEnabledLabel: 'This tutorial video is ready to be viewed by the user.',
  Title: 'Title',
  FunctionTitle: 'Function',
  View: 'View',
  SynchronizeVideos: 'Synchronize videos',
  Synchronize: 'Synchronize',
  ErrorCreatingVideo: 'There was an error creating the video. Please verify the entered information and try again.',
  ErrorEditingVideo: 'There was an error editing the video. Please verify the entered information and try again.',
  Duration: 'Duration',
  SelectOrInviteUser: 'Select or invite user',
  SelectOrInviteUsers: 'Select or invite users',
  CheckDB: 'Check database',
  ManageGlobalLicenses: 'Manage global licenses',
  ManageRoleAssignments: 'Manage role assignments',
  ManageUnitSystems: 'Manage unit systems',
  ShareDrillhole: 'Share drillholes',
  SignOffSurveys: 'Sign off surveys',
  ViewSurveyData: 'View survey data',
  OrganizationLogs: 'Organization Logs',
  ExportOrganizationDBLogsModalTitle: 'Export organization database check logs',
  Format: 'Format',
  OrganizationBackups: 'Organization Backups',
  PreviousValue: 'Previous Value',
  PreviousHierarchy: 'Previous Hierarchy',
  Source: 'Source',
  SourceTitle: 'Source for the log with date {0}, previous value "{1}" and previous hierarchy "{2}"',
  ViewSource: 'View Source',
  ScopeId: 'Scope Id',
  CurrentParentId: 'Current Parent Id',
  PreviousParentId: 'Previous Parent Id',
  CurrentHierarchy: 'Current Hierarchy',
  ScopeLogType: 'Scope Log Type',
  Descendants: 'Descendants',
  ViewDescendants: 'View Descendants',
  DatabaseInconsistencyLogs: 'Database Inconsistency Logs',
  InconsistencyFixStartedMessage:
    'The inconsistency fix process has started, once finished the result will be visible on the Organization Logs page.',
  OrganizationIsLocked: 'This organization is currently locked because it is being used in another process. Please wait and try again in a while.',
  Statistics: 'Statistics',
  Last24Hours: 'Last 24 hours',
  Last3Days: 'Last 3 days',
  Last7Days: 'Last 7 days',
  Last28Days: 'Last 28 days',
  FilterByDate: 'Filter by date',
  Projects: 'Projects',
  Surveys: 'Surveys',
  ProjectsNumber: 'No. of Projects',
  UsersNumber: 'No. of Users',
  SurveysNumber: 'No. of Surveys',
  CreationDate: 'Creation Date',
  LastUpdate: 'Last Update',
  CustomDateRange: 'Custom date range',
  ErrorUpdatingRole: 'There was an error updating the role permissions. Please try again.',

  WorkingHours: 'Working Hours',
  PleaseEnterWorkingHours: 'Please enter working hours',

  Weekly: 'Weekly',
  Monthly: 'Montly',
  Quarterly: 'Quarterly',
  SharingDataSettings: 'Sharing data settings',
  EmailAddresses: 'EmailAddresses',
  EmailFrequency: 'EmailFrequency',

  Country: 'Country',
  PleaseSelectCountry: 'Please select a country',

  // Country names
  Afghanistan: 'Afghanistan',
  Albania: 'Albania',
  Algeria: 'Algeria',
  Andorra: 'Andorra',
  Angola: 'Angola',
  'Antigua and Barbuda': 'Antigua and Barbuda',
  Argentina: 'Argentina',
  Armenia: 'Armenia',
  Australia: 'Australia',
  Austria: 'Austria',
  Azerbaijan: 'Azerbaijan',
  Bahamas: 'Bahamas',
  Bahrain: 'Bahrain',
  Bangladesh: 'Bangladesh',
  Barbados: 'Barbados',
  Belarus: 'Belarus',
  Belgium: 'Belgium',
  Belize: 'Belize',
  Benin: 'Benin',
  Bhutan: 'Bhutan',
  Bolivia: 'Bolivia',
  'Bosnia and Herzegovina': 'Bosnia and Herzegovina',
  Botswana: 'Botswana',
  Brazil: 'Brazil',
  Brunei: 'Brunei',
  Bulgaria: 'Bulgaria',
  'Burkina Faso': 'Burkina Faso',
  Burundi: 'Burundi',
  Cambodia: 'Cambodia',
  Cameroon: 'Cameroon',
  Canada: 'Canada',
  'Cape Verde': 'Cape Verde',
  'Central African Republic': 'Central African Republic',
  Chad: 'Chad',
  Chile: 'Chile',
  China: 'China',
  Colombia: 'Colombia',
  Comoros: 'Comoros',
  'Costa Rica': 'Costa Rica',
  'Côte d’Ivoire': 'Côte d’Ivoire',
  Croatia: 'Croatia',
  Cuba: 'Cuba',
  Cyprus: 'Cyprus',
  'Czech Republic': 'Czech Republic',
  'Democratic Republic of the Congo': 'Democratic Republic of the Congo',
  Denmark: 'Denmark',
  Djibouti: 'Djibouti',
  Dominica: 'Dominica',
  'Dominican Republic': 'Dominican Republic',
  'East Timor': 'East Timor',
  Ecuador: 'Ecuador',
  Egypt: 'Egypt',
  'El Salvador': 'El Salvador',
  'Equatorial Guinea': 'Equatorial Guinea',
  Eritrea: 'Eritrea',
  Estonia: 'Estonia',
  Ethiopia: 'Ethiopia',
  Fiji: 'Fiji',
  Finland: 'Finland',
  France: 'France',
  Gabon: 'Gabon',
  Gambia: 'Gambia',
  Georgia: 'Georgia',
  Germany: 'Germany',
  Ghana: 'Ghana',
  Greece: 'Greece',
  Grenada: 'Grenada',
  Guatemala: 'Guatemala',
  Guinea: 'Guinea',
  'Guinea-Bissau': 'Guinea-Bissau',
  Guyana: 'Guyana',
  Haiti: 'Haiti',
  Honduras: 'Honduras',
  Hungary: 'Hungary',
  Iceland: 'Iceland',
  India: 'India',
  Indonesia: 'Indonesia',
  Iran: 'Iran',
  Iraq: 'Iraq',
  Ireland: 'Ireland',
  Israel: 'Israel',
  Italy: 'Italy',
  Jamaica: 'Jamaica',
  Japan: 'Japan',
  Jordan: 'Jordan',
  Kazakhstan: 'Kazakhstan',
  Kenya: 'Kenya',
  Kiribati: 'Kiribati',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Kyrgyzstan',
  Laos: 'Laos',
  Latvia: 'Latvia',
  Lebanon: 'Lebanon',
  Lesotho: 'Lesotho',
  Liberia: 'Liberia',
  Libya: 'Libya',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lithuania',
  Luxembourg: 'Luxembourg',
  Madagascar: 'Madagascar',
  Malawi: 'Malawi',
  Malaysia: 'Malaysia',
  Maldives: 'Maldives',
  Mali: 'Mali',
  Malta: 'Malta',
  'Marshall Islands': 'Marshall Islands',
  Mauritania: 'Mauritania',
  Mauritius: 'Mauritius',
  Mexico: 'Mexico',
  Micronesia: 'Micronesia',
  Moldova: 'Moldova',
  Monaco: 'Monaco',
  Mongolia: 'Mongolia',
  Montenegro: 'Montenegro',
  Morocco: 'Morocco',
  Mozambique: 'Mozambique',
  Myanmar: 'Myanmar',
  Namibia: 'Namibia',
  Nauru: 'Nauru',
  Nepal: 'Nepal',
  Netherlands: 'Netherlands',
  'New Zealand': 'New Zealand',
  Nicaragua: 'Nicaragua',
  Niger: 'Niger',
  Nigeria: 'Nigeria',
  'North Korea': 'North Korea',
  Norway: 'Norway',
  Oman: 'Oman',
  Pakistan: 'Pakistan',
  Palau: 'Palau',
  Panama: 'Panama',
  'Papua New Guinea': 'Papua New Guinea',
  Paraguay: 'Paraguay',
  Peru: 'Peru',
  Philippines: 'Philippines',
  Poland: 'Poland',
  Portugal: 'Portugal',
  Qatar: 'Qatar',
  'Republic of the Congo': 'Republic of the Congo',
  'Republic of Macedonia': 'Republic of Macedonia',
  Romania: 'Romania',
  Russia: 'Russia',
  Rwanda: 'Rwanda',
  'Saint Kitts and Nevis': 'Saint Kitts and Nevis',
  'Saint Lucia': 'Saint Lucia',
  'Saint Vincent and the Grenadines': 'Saint Vincent and the Grenadines',
  Samoa: 'Samoa',
  'San Marino': 'San Marino',
  'Sao Tome and Principe': 'Sao Tome and Principe',
  'Saudi Arabia': 'Saudi Arabia',
  Senegal: 'Senegal',
  Serbia: 'Serbia',
  Seychelles: 'Seychelles',
  'Sierra Leone': 'Sierra Leone',
  Singapore: 'Singapore',
  Slovakia: 'Slovakia',
  Slovenia: 'Slovenia',
  'Solomon Islands': 'Solomon Islands',
  Somalia: 'Somalia',
  'South Africa': 'South Africa',
  'South Korea': 'South Korea',
  'South Sudan': 'South Sudan',
  Spain: 'Spain',
  'Sri Lanka': 'Sri Lanka',
  Sudan: 'Sudan',
  Suriname: 'Suriname',
  Swaziland: 'Swaziland',
  Sweden: 'Sweden',
  Switzerland: 'Switzerland',
  Syria: 'Syria',
  Tajikistan: 'Tajikistan',
  Tanzania: 'Tanzania',
  Thailand: 'Thailand',
  Togo: 'Togo',
  Tonga: 'Tonga',
  'Trinidad and Tobago': 'Trinidad and Tobago',
  Tunisia: 'Tunisia',
  Turkey: 'Turkey',
  Turkmenistan: 'Turkmenistan',
  Tuvalu: 'Tuvalu',
  Uganda: 'Uganda',
  Ukraine: 'Ukraine',
  'United Arab Emirates': 'United Arab Emirates',
  'United Kingdom': 'United Kingdom',
  'United States of America': 'United States of America',
  Uruguay: 'Uruguay',
  Uzbekistan: 'Uzbekistan',
  Vanuatu: 'Vanuatu',
  Venezuela: 'Venezuela',
  Vietnam: 'Vietnam',
  Yemen: 'Yemen',
  Zambia: 'Zambia',
  Zimbabwe: 'Zimbabwe',

  TestOrganization: 'Test Organization',
  RemovalDate: 'Removal date',
  IsTestOrganization: 'Is a test organization',
  TestingEndDate: 'Testing end date:',
  TestOrgConfirmationMessage:
    'The entity has been established as a test organization and will be automatically deleted on the selected date. Are you sure you want to continue?',

  Show: 'Show',
  Changed: 'Changed',
  Unchanged: 'Unchanged',

  Charts: 'Charts',

  CreationChartLegend: 'Creation',
  UpdateChartLegend: 'Update',

  Confirm: 'Confirm',

  SelectOrInviteWarning: 'Please select or invite',
  InvalidEmailWarning: 'Please select or type a valid email',

  UserHasNoOrganizationsWarning: 'This user is not part of any organization. Please add them to an organization before assigning roles.',
  UserHasNoOrganizationsGroupWarning: 'This user is not part of any organization. Please add them to an organization before assigning groups.',

  'Customer Geologist': 'Customer Geologist',
  'Drillhole Manager': 'Drillhole Manager',
  'Field Operator': 'Field Operator',
  Geologist: 'Geologist',
  'Global License Manager': 'Global License Manager',
  'License Manager': 'License Manager',
  'Organization Coordinator': 'Organization Coordinator',
  'Organization Master': 'Organization Master',
  'Partner Administrator': 'Partner Administrator',
  'Project Manager': 'Project Manager',
  'Project Viewer': 'Project Viewer',
  'Ring Manager': 'Ring Manager',
  ViewAllOrganizations: 'View all organizations',
  'Organizations Viewer': 'Organizations Viewer',

  GlobalLicenseAlreadyExists:
    'You are trying to create a new global license for {0} #{1} from {6} to {7}, but there is a global license already created for {0} #{1} from {2} to {3} by {4} on {5}. Do you want to continue and create a new license anyway?',
  UnlimitedGlobalLicenseAlreadyExists:
    'There is an unlimited global license already created for {0} #{1} by {2} on {3}. Do you want to continue and create a new license anyway?',
  Continue: 'Continue',

  EditWarningGlobalLicenseAlreadyExists:
    'There is a global license already created for {0} #{1} from {2} to {3} by {4} on {5}. Do you want to continue?',
  EditWarningUnlimitedGlobalLicenseAlreadyExists:
    'There is an unlimited global license already created for {0} #{1} by {2} on {3}. Do you want to continue?',
  EditWarningLicenseAlreadyExists:
    'There is a license already created for {0} #{1} from {2} to {3} by {4} on {5} in the organization {6}. Do you want to continue?',
  EditWarningUnlimitedLicenseAlreadyExists:
    'There is an unlimited license already created for {0} #{1} by {2} on {3} in the organization {4}. Do you want to continue?',

  UserLogin: 'User Login',
  UserAccessOrganization: 'User Access Organization',
  UserLogout: 'User Logout',
  UserAddedToGroup: 'User Added To Group',
  UserRemovedFromGroup: 'User Removed From Group',
  RoleAssignedToUser: 'Role Assigned To User',
  RoleUnassignedToUser: 'Role Unassigned To User',
  RoleAssignedToGroup: 'Role Assigned To Group',
  RoleUnassignedToGroup: 'Role Unassigned To Group',
  InvitationAccepted: 'Invitation Accepted',
  BackupSuccess: 'Backup Success',
  BackupError: 'Backup Error',
  RestoreBackupSuccess: 'Restore Backup Success',
  RestoreBackupError: 'Restore Backup Error',
  PleaseEnterStartAndEndDate: 'Please enter start and end date',

  ActiveHours: 'Active hours',
  Active: 'Active',
  NotActive: 'Not active',
  FilterByActiveDates: 'Filter by active dates',
  ActiveDays: 'Active days',
  SelectedGroupAlreadyHasTheSelectedRoles: 'The selected group already has the roles: {0}.',

  Apply: 'Apply',

  FilterMode: 'Filter mode',
  AllSelected: 'All selected',
  AnyOfTheSelected: 'Any of the selected',

  Download: 'Download',

  ErrorCreatingLicense: 'Error creating license',
  DeviceTypeNotAllowed: 'Device type not allowed',

  RoleAssignmentAttributes: 'Role assignment attributes',
  LicenseManagerRoleAttributes: 'License Manager role attributes',

  'StructMaster User': 'StructMaster User',
  UseStructMaster: 'Use StructMaster',

  StructmasterLicenses: 'StructMaster licenses',
  NewStructmasterLicenseAssignment: 'New StructMaster license assignment',
  EditStructmasterLicenseAssignment: 'Edit StructMaster license assignment',
  UserAlreadyHasStructMasterRole: 'Error: This user already has the StrucMaster role for this organization',
  AddAnotherAssignment: 'Add another assignment',
  AddRole: 'Add role',
  SelectRole: 'Select role',
  PleaseSelectRole: 'Please select a role',
  DuplicatedRolesWarning: 'There are duplicate roles in your selection. Please ensure there are no duplicate roles.',
  RolesWillBeUpdated: 'The following roles will be updated: {0}. ',

  UserHasNoRoleWarning: 'The user must have at least one role in the organization',

  UserWillBeAddedToOrganizationBeforeAssign:
    'Warning: The user "{0}" does not belong to the organization "{1}", therefore, the user "{0}" will be added to the organization before making the assignment.',

  ManageCategories: 'Manage categories',
  ManageGeographicInformationSystems: 'Manage geographic information systems',

  RoleExpirationDateChanged: 'Role expiration date changed',

  Appearance: 'Appearance',
  DarkTheme: 'Dark theme',
  LightTheme: 'Light theme',
  UseSystemTheme: 'Use system theme',
  MFAStatus: 'Multi-Factor Authentication Status',
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  EnableMFA: 'Enable Multi-Factor Authentication',
  DisableMFA: 'Disable Multi-Factor Authentication',

  UserLimit: 'User limit',
  PleaseEnterUserLimit: 'Please enter user limit',
  CheckLicenseInfoAndUsersTabs: 'Please check lincense info and user tabs. Something is wrong',
  LicenseInfo: 'License Info',
  AddNewStructmasterLicense: 'Add new StructMaster license',
  StructmasterLicense: 'StructMaster license',
  PleaseAddAtLeastOneUser: 'Please add at least one user',
  DuplicatedUserWarning: 'This user is already selected, please verify',
  LicenseName: 'License name',
  UserAmountExceedLimit: 'The number of users entered exceeds the selected limit, please check that the data is correct.',

  UserAlreadyIsLicenseManagerError: 'This user is already on a License Manager group. Please select a different user',
  UserAlreadyIsStructmasterUserError: 'This user already has the StructMaster role. Please select a different user',
  DefaultGroups: 'Default groups',
  LicenseManagerGroups: 'License Manager groups',
  UpdateAttributes: 'Update Attributes',
  ResetLicenseAccess: 'Reset license access',

  UserOnAddGroupAlreadyIsLicenseManagerError:
    'This user is already on a License Manager group, and there is at least one License Manager group in your selection. Please review it.',
  MoreThanOneLicenseManagerGroupSelectedError:
    'There is more than one License Manager group in your selection, and an user can only be on a single License Manager group. Please review your selection.',
  Default: 'Default',

  UnblockStructmasterLicense: 'Unblock StructMaster License',

  ThereIsAlreadyAStructmasterLicenseWithThisName: 'There is already a StructMaster license with this name, please select a different name.',
  ThereIsAlreadyAGroupWithThisName: 'There is already a group with this name, please select a different name',

  GroupLogsTableError: 'There was an error loading group audit logs. Please try again.',
  DownloadQR: 'Download QR',

  SelectUsersToShare: 'Select users to share',
  SelectOrEnterEmailAddress: 'Select user or enter email address',
  Share: 'Share',
  NoUsersSelectedError: 'Please select at least one user or enter an email adress',
  AddEmail: 'Add Email',
  FilterByUser: 'Filter by user',
  ApprovalPending: 'Approval Pending',

  ActiveUser: 'Active user',

  AllowAllPermissionsForThisLevel: 'Allow all permissions for this level',
  AllowAllAvailablePermissions: 'Allow all available permissions',
  AllowAllAvaliablePermissionsForThisSelector: 'Allow all avaliable permissions for this selector',

  StructmasterLicensesOnlyOneActiveUserWarning: 'Warning: There can only be one active user at a time for each StructMaster license.',

  OrganizationUserLimitWarningCreation: 'Warning: You can only add a maximum of {0} users to an organization',
  OrganizationUserLimitWarningParam:
    'Warning: You can only add a maximum of {0} users to this organization and you already have a total of {1}, so you will only be able to add a total of {2}.',
  OrganizationReachedUserLimit: 'Error: This organization already has the maximum number of users allowed. Please select another organization.',
  NewGroupUserCountErrorParam:
    'Error: This organization has a maximum of {0} users with a current amount of {1} users, and you are trying to add {2} new users. Please check that the information is correct.',
  TheFollowingUsersWillBeAddedToTheOrganization: 'The following users will be added to the organization:',

  UnsignedStructmasterLicenses: 'Unsinged StructMaster licenses',
  SaveAndSignOff: 'Save and sing off',
  SignOffStructmasterLicenseWarningTitle: 'Sign Off StructMaster License',
  SignOffStructmasterLicenseWarningMessage:
    'You are about to approve the creation of a new StructMaster license. Users will be added to the selected organization if they are not already there and the role will be assigned. Do you want to continue?',

  ShowOnlyUnsignedLicenses: 'Show only licenses pending approval',
  ClearFilters: 'Clear filters',
  ApproveLicenses: 'Approve Licenses',

  SoftwareVersion: 'Software version',
  DeleteUnsignedLicense: 'Delete unsigned license',
  DeleteUnsignedLicenseWarning: 'Are you sure you want to delete the unsigned license "{0}"?',

  ErrorUpdatingLicense: 'Error updating license',
  DuplicatedRoleNameErrorCreate:
    'Error creating role: A role with the name "{0}" already exists in organization "{1}". Please enter a different name.',
  DuplicatedRoleNameErrorUpdate:
    'Error updating role: A role with the name "{0}" already exists in organization "{1}". Please enter a different name.',
  DuplicatedDefaultRoleNameErrorUpdate: 'Error updating role: A default role with the name "{0}" already exists. Please enter a different name.',
  PleaseEnterAValidSearchTerm: 'Please enter a valid search term',
  TextFieldLimitError: 'The field "{0}" must not exceed {1} characters',
  InvalidToolcode: 'Please enter a valid tool code',
  LicenseManagerGroupsMustHaveAtLeastOneRole: 'License manager groups must have at least one role',
  PleaseSelectAtLeastOneDeviceType: 'Please select at least one device type',
  Language: 'Language',

  UnsignedLicenseCreation: 'Unsigned license creation',
  SignedLicenseCreation: 'Signed license creation',
  UnsignedLicenseUpdate: 'Unsigned license update',
  SignedLicenseUpdate: 'Signed license update',
  ErrorCreatingUnsignedLicense: 'Error creating unsigned license',
  ErrorCreatingSignedLicense: 'Error creating signed license',
  ErrorUpdatingUnsignedLicense: 'Error updating unsigned license',
  ErrorUpdatingSignedLicense: 'Error updating signed license',
  DeleteSignedLicense: 'Delete signed license',
  StructmasterLicenseLogs: 'StructMaster license logs',
  PleaseEnterCoreDiameter: 'Please enter core diameter',
  CoreDiameter: 'Core diameter',

  AllowedGrantTypes: 'Allowed grant types',
  Clients: 'Clients',
  ClientsTableError: 'There was an error loading clients. Please try again.',
  AllowedScopes: 'Allowed scopes',
  Implicit: 'Implicit',
  Hybrid: 'Hybrid',
  AuthorizationCode: 'Authorization Code',
  ClientCredentials: 'Client Credentials',
  ResourceOwnerPassword: 'Resource Owner Password',
  DeviceFlow: 'Device Flow',
  Profile: 'Profile',
  Phone: 'Phone',
  OfflineAccess: 'Offline Access',
  RedirectUris: 'Redirect URIs',
  PostLogoutRedirectUris: 'Post logout redirect URIs',
  AccessTokenType: 'Access token type',
  RefreshTokenUsage: 'Refresh token usage',
  AccessTokenLifetime: 'Access token lifetime',
  AbsoluteRefreshTokenLifetime: 'Absolute refresh token lifetime',
  AllowAccessTokensViaBrowser: 'Allow access tokens via browser',
  AllowOfflineAccess: 'Allow offline access',
  AlwaysIncludeUserClaimsInIdToken: 'Always include user claims on Id Token',
  RequirePkce: 'Require PKCE',
  RequireConsent: 'Require consent',
  RequireClientSecret: 'Require client secret',
  ClientID: 'Client ID',
  ClientName: 'Client name',
  ProtocolType: 'Protocol type',
  NewClient: 'New client',
  EditClient: 'Edit client',
  General: 'General',
  ClientSecrets: 'Client secrets',
  PleaseEnterAClientId: 'Please enter a client ID',
  PleaseEnterAClientName: 'Please enter a client name',
  ReUse: 'Reuse',
  OneTimeOnly: 'One time only',
  PleaseSelectTheAllowedScopes: 'Please select the allowed scopes',
  AddRedirectUri: 'Add redirect URI',
  AddPostLogoutRedirectUri: 'Add post logout redirect URI',
  PleaseEnterRedirectURI: 'Please enter a redirect URI',
  PleaseEnterPostLogoutRedirectURI: 'Please enter a post logout redirect URI',
  Value: 'Value',
  PleaseEnterSecretValue: 'Please enter secret value',
  PleaseEnterSecretDescription: 'Please enter secret description',
  AddClientSecret: 'Add client secret',
  NoRedirectUriWarning: 'Please add at least one redirect URI on the "Redirect URIs" tab',
  NoPostLogoutRedirectUriWarning: 'Please add at least one post logout redirect URI on the "Redirect URIs" tab',
  NoSecretsWarning: 'If "Require client secret" is checked, you must add at least one secret on the "Client secrets" tab',
  PleaseSelectTheAllowedGrantTypes: 'Please select the allowed grant types',
  RedirectURIMustNotBeEmpty: 'The redirect URI value must not be empty',
  PostLogoutRedirectURIMustNotBeEmpty: 'The post logout redirect URI value must not be empty',
  SecretValueMustNotBeEmpty: 'The value of the secret must not be empty',
  SecretDescriptionMustNotBeEmpty: 'The description of the secret must not be empty',
  AllDataEnterdIsCorrect: 'All data entered is correct',
  NoChangesMadeWarning: 'There are no changes to save. Update any field to continue.',
  ConfirmEditSecretValueTitle: 'Confirm edit secret value',
  ConfirmEditSecretValueMessage:
    'Are you sure you want to edit the value for the secret with description "{0}"? If you continue, the previous secret value will be lost.',
  ManageClients: 'Manage clients',
  Usage: 'Usage',

  GlobalSmartCoreLicenseAlreadyExists:
    'You are trying to create a new global license for {0} #{1} from {6} to {7} with tool diameter "{8}", but there is a global license already created for {0} #{1} with tool diameter "{8}" from {2} to {3} by {4} on {5}. Do you want to continue and create a new license anyway?',
  UnlimitedGlobalSmartCoreLicenseAlreadyExists:
    'There is an unlimited global license already created for {0} #{1} with tool diameter "{4}" by {2} on {3}. Do you want to continue and create a new license anyway?',
  EditWarningGlobalSmartCoreLicenseAlreadyExists:
    'There is a global license already created for {0} #{1} with tool diameter "{7}" from {2} to {3} by {4} on {5}. Do you want to continue?',
  EditWarningUnlimitedGlobalSmartCoreLicenseAlreadyExists:
    'There is an unlimited global license already created for {0} #{1} with tool diameter "{5}" by {2} on {3}. Do you want to continue?',
  ToolDiameter: 'Tool diameter',
  ToolcodeTooLarge: 'The tool code is too large. The tool code must be a number between 1 and 65535',
  NotAllChildrenAreTestOrganizations:
    'This organization cannot be set as a test organization since at least one of its child organizations is not a test organization',
  'License Reviewer': 'License Reviewer',
  'Client Manager': 'Client Manager',
  MeasurementCount: 'Surveys',
  ToolSerialNumber: 'Tool serial number',
  ExportCsvReport: 'Export CSV report',
  ToolType: 'Tool type',
  FirstUsedOn: 'First usage date',
  LastUsedOn: 'Last usage date',
  ErrorGeneratingReport: 'There was an error generating the report. Please try again.',
  ToolUsageReport: 'Tool usage report',
  ExportToolUsageReport: 'Export tool usage report',
  ToolUsageReportInProcess: "The tool usage report is being generated. It will be sent to your email address when it's finished.",
  ProjectName: 'Project name',
  ManagePartnerOrganization: 'Manage partner organization',
  ManageAdminOrganization: 'Manage admin organization',
};
